import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Alert, Box, Divider, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getBatchMedia } from '../../../../../../actions/conservation-burns/conservation-burn-actions';

export default function CbBatchMedia({ projectKey }) {
    const dispatch = useDispatch()
    const cbMedia = useSelector(state => state.conservationBurnsReducer.batchMedia)?.data
    const [hideState, setHideState] = useState({})

    useEffect(() => {
        dispatch(getBatchMedia(projectKey))
    }, [dispatch, projectKey])

    const toggleHide = (batchId) => {
        setHideState(prevState => ({
            ...prevState,
            [batchId]: !prevState[batchId]
        }))
    }

    const renderPhotos = (photos, title) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant='h6'>{title}</Typography>
            {!photos.length
                ? <Alert severity="info">No {title} media</Alert>
                : <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                        gap: '16px',
                    }}>
                    {photos.map((photo, index) => (
                        <img
                            key={index}
                            src={photo}
                            alt={`${title} Photo ${index}`}
                            width="300" />
                    ))}
                </Box>
            }
        </Box>
    )

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Typography variant='h5'>Conservation Burns Batch Media</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                {cbMedia && cbMedia.map((batch, index) => {
                    /*
                    cbFeedstockDiameterPhotos
                    cbFeedstockHeightPhotos
                    cbFeedstockMoisturePhotos
                    */
                    const hasNoCbMedia =
                        !batch.cbFeedstockDiameterPhotos.length &&
                        !batch.cbFeedstockHeightPhotos.length &&
                        !batch.cbFeedstockMoisturePhotos.length

                    return (
                        <Box key={index}>
                            {hasNoCbMedia && (
                                <Alert severity="info" sx={{ my: 3 }}>No Conservation Burn Media for Batch: {batch.batchId}</Alert>
                            )}
                            {!hasNoCbMedia && (
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                        onClick={() => toggleHide(`ROF - ${batch.batchId}`)}
                                    >
                                        <Typography>{hideState[`ROF - ${batch.batchId}`] ? "Hide" : "Expand"} {batch.batchId}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography variant='h6'>Conservation Burn Media for Batch: {batch.batchId}</Typography>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                            {renderPhotos(batch.cbFeedstockDiameterPhotos, 'Feedstock Diameter Photos')}
                                            {renderPhotos(batch.cbFeedstockHeightPhotos, 'Feedstock Height Photos')}
                                            {renderPhotos(batch.cbFeedstockMoisturePhotos, 'Moisture Content Photos')}
                                        </Box>
                                        <Divider />
                                    </AccordionDetails>
                                </Accordion>
                            )}
                        </Box>
                    )
                })}
            </Box>
            {/* <h2>Conservation Burns Batch Media</h2>
            {cbMedia && cbMedia.map((batch, index) => {
                const hasNoConservationBurnMedia =
                    !batch.cbMoistureContentPhotos.length &&
                    !batch.cbLogPileSizePhotos.length &&
                    !batch.cbLogFeedstockPileCountPhotos.length &&
                    !batch.cbBulkDensityPhotos.length &&
                    !batch.cbVolumeMeasurementPhotos.length &&
                    !batch.cbLogBiocharPileCountPhotos.length

                return (
                    <Box key={index}>
                        {hasNoConservationBurnMedia && (
                            <Alert severity="info" sx={{ my: 3 }}>No Conservation Burn Media for Batch: {batch.batchId}</Alert>
                        )}
                        {!hasNoConservationBurnMedia && (

                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    onClick={() => toggleHide(`CB - ${batch.batchId}`)}
                                >
                                    <Typography>{hideState[`CB - ${batch.batchId}`] ? "Hide" : "Expand"} {batch.batchId}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <h3>Conservation Burn Media for Batch: {batch.batchId}</h3>
                                    {renderPhotos(batch.cbMoistureContentPhotos, 'Moisture Content')}
                                    {renderPhotos(batch.cbLogPileSizePhotos, 'Log Pile Size')}
                                    {renderPhotos(batch.cbLogFeedstockPileCountPhotos, 'Log Feedstock Pile Count')}
                                    {renderPhotos(batch.cbBulkDensityPhotos, 'Bulk Density')}
                                    {renderPhotos(batch.cbVolumeMeasurementPhotos, 'Volume Measurement')}
                                    {renderPhotos(batch.cbLogBiocharPileCountPhotos, 'Log Biochar Pile Count')}
                                </AccordionDetails>
                            </Accordion>
                        )}
                    </Box>
                )
            })} */}
        </Box>
    )
}